/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenVulnCountSnapshot } from './OpenVulnCountSnapshot';
import {
    OpenVulnCountSnapshotFromJSON,
    OpenVulnCountSnapshotFromJSONTyped,
    OpenVulnCountSnapshotToJSON,
    OpenVulnCountSnapshotToJSONTyped,
} from './OpenVulnCountSnapshot';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { KevAssetGroupDto } from './KevAssetGroupDto';
import {
    KevAssetGroupDtoFromJSON,
    KevAssetGroupDtoFromJSONTyped,
    KevAssetGroupDtoToJSON,
    KevAssetGroupDtoToJSONTyped,
} from './KevAssetGroupDto';

/**
 * 
 * @export
 * @interface KevBlastRadiusResponse
 */
export interface KevBlastRadiusResponse {
    /**
     * 
     * @type {number}
     * @memberof KevBlastRadiusResponse
     */
    openKevFindingCount?: number;
    /**
     * 
     * @type {number}
     * @memberof KevBlastRadiusResponse
     */
    affectedAssetCount?: number;
    /**
     * 
     * @type {OpenVulnCountSnapshot}
     * @memberof KevBlastRadiusResponse
     */
    severityBreakdown?: OpenVulnCountSnapshot;
    /**
     * 
     * @type {Array<KevAssetGroupDto>}
     * @memberof KevBlastRadiusResponse
     */
    assetGroups?: Array<KevAssetGroupDto>;
    /**
     * 
     * @type {number}
     * @memberof KevBlastRadiusResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof KevBlastRadiusResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof KevBlastRadiusResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof KevBlastRadiusResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof KevBlastRadiusResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the KevBlastRadiusResponse interface.
 */
export function instanceOfKevBlastRadiusResponse(value: object): value is KevBlastRadiusResponse {
    return true;
}

export function KevBlastRadiusResponseFromJSON(json: any): KevBlastRadiusResponse {
    return KevBlastRadiusResponseFromJSONTyped(json, false);
}

export function KevBlastRadiusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): KevBlastRadiusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'openKevFindingCount': json['openKevFindingCount'] == null ? undefined : json['openKevFindingCount'],
        'affectedAssetCount': json['affectedAssetCount'] == null ? undefined : json['affectedAssetCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : OpenVulnCountSnapshotFromJSON(json['severityBreakdown']),
        'assetGroups': json['assetGroups'] == null ? undefined : ((json['assetGroups'] as Array<any>).map(KevAssetGroupDtoFromJSON)),
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function KevBlastRadiusResponseToJSON(json: any): KevBlastRadiusResponse {
    return KevBlastRadiusResponseToJSONTyped(json, false);
}

export function KevBlastRadiusResponseToJSONTyped(value?: KevBlastRadiusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'openKevFindingCount': value['openKevFindingCount'],
        'affectedAssetCount': value['affectedAssetCount'],
        'severityBreakdown': OpenVulnCountSnapshotToJSON(value['severityBreakdown']),
        'assetGroups': value['assetGroups'] == null ? undefined : ((value['assetGroups'] as Array<any>).map(KevAssetGroupDtoToJSON)),
        'queryDurationMs': value['queryDurationMs'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

